import React, { Component, Fragment } from 'react';
import AbsoluteWrapper from "./AbsoluteWrapper";

import MainPage         from './pictures/MainTable.PNG' ;
import Favorite         from './pictures/Favorite.PNG' ;
import react_chart      from './pictures/stock_pick_chart.PNG' ;
import mapping          from './pictures/mapping.PNG' ; //Trade_History

import riskMetrics      from './pictures/riskMetrics.jpg' ;
import Alerts           from './pictures/Alerts.PNG' ;
import EOCycle          from './pictures/EOCycle.PNG' ;

import TradingRange     from './pictures/TradingRange.PNG' ;
import Trade_History    from './pictures/Trade_History.PNG' ; //Trade_History
import OpenedPosition   from './pictures/OpenedPosition.PNG' ; //Trade_History

import MassCom          from './pictures/MassCom.PNG' ; //Trade_History

import doc              from './pictures/doc.PNG' ; //Trade_History
import feedback         from './pictures/feedback.PNG' ; //Trade_History

import MainChart        from './pictures/MainChart.jpg' ; //Trade_History







class Solutions extends Component {


  constructor(props) {
    super(props);

    this.state.Doc_showing = false
    this.handleMouseHover_Dash = this.handleMouseHover_Dash.bind(this);
    this.handleMouseHover_Picks = this.handleMouseHover_Picks.bind(this);
    this.handleMouseHover_Signal = this.handleMouseHover_Signal.bind(this);
    this.handleMouseHover_Chart = this.handleMouseHover_Chart.bind(this);
    this.handleMouseHover_Risk = this.handleMouseHover_Risk.bind(this);
    this.handleMouseHover_Simulator = this.handleMouseHover_Simulator.bind(this);
    this.handleMouseHover_Report = this.handleMouseHover_Report.bind(this);

    /*this.state = {
      isHovering: false,
    };*/

  }




  state = {

    Doc_showing : false,

    Dashborad_isShow : true,

    StockPicks_isShow : false,
    StockPicks_signal_isShow : false,
    StockPicks_tr_isShow : false,
    StockPicks_risk_isShow : false,
    StockPicks_chart_isShow : false,
    APIs_isShow : false,
    Favorite_isShow : false,
    StockPicks_eoc_isShow : false,

    Feedback_isShow : false,
    doc_isShow : false,

    active_trades_isShow : false,
    idms_signals_isShow : false,
    mass_communication_isShow : false,

    Signal_isShow : false,
    Chart_isShow : false,
    Risk_isShow : false,
    Financial_isShow : false,
    Simulator_isShow : false,
    Tracker_isShow : false,

    isHovering_Dash: false,
    isHovering_Picks: false,
    isHovering_Chart: false,
    isHovering_Risk: false,
    isHovering_Signal: false,
    isHovering_Simulator: false,
    isHovering_Report: false,

    showing: true,
  };
  




  handleDashborad = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.Dashborad_isShow == false) {
               this.setState({ Dashborad_isShow: true });

               this.setState({ StockPicks_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
      }
      else if ( this.state.Dashborad_isShow == true) {
               this.setState({ Dashborad_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }


  handleStockPicks_stockPick = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.StockPicks_isShow == false) {

               this.setState({ StockPicks_isShow: true });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });

               this.setState({ active_trades_isShow: false });
               this.setState({ idms_signals_isShow: false });
               this.setState({ mass_communication_isShow: false });

               this.setState({ Dashborad_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
               this.setState({ Feedback_isShow: false });
               this.setState({ doc_isShow: false });
      }
      else if ( this.state.StockPicks_isShow == true) {
               this.setState({ StockPicks_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }


  
  handleStockPicks_Signals = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.StockPicks_signal_isShow == false) {

              this.setState({ StockPicks_signal_isShow: true });

              this.setState({ StockPicks_isShow: false });
              this.setState({ StockPicks_tr_isShow: false });
              this.setState({ StockPicks_risk_isShow: false });
              this.setState({ StockPicks_chart_isShow: false });

              this.setState({ active_trades_isShow: false });
              this.setState({ idms_signals_isShow: false });
              this.setState({ mass_communication_isShow: false });


               this.setState({ Dashborad_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
               this.setState({ Feedback_isShow: false });
               this.setState({ doc_isShow: false });
      }
      else if ( this.state.StockPicks_signal_isShow == true) {
               this.setState({ StockPicks_signal_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }



  

  
  
  
  handleStockPicks_eoc = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.StockPicks_eoc_isShow == false) {

               this.setState({ StockPicks_eoc_isShow: true });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_chart_isShow: false });

               this.setState({ active_trades_isShow: false });
               this.setState({ idms_signals_isShow: false });
               this.setState({ mass_communication_isShow: false });

               this.setState({ Dashborad_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
               this.setState({ Feedback_isShow: false });
               this.setState({ doc_isShow: false });
      }
      else if ( this.state.StockPicks_eoc_isShow == true) {
               this.setState({ StockPicks_eoc_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }


  
  handleStockPicks_TradingRange = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.StockPicks_tr_isShow == false) {

               this.setState({ StockPicks_tr_isShow: true });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_chart_isShow: false });

               this.setState({ active_trades_isShow: false });
               this.setState({ idms_signals_isShow: false });
               this.setState({ mass_communication_isShow: false });

               this.setState({ Dashborad_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
               this.setState({ Feedback_isShow: false });
               this.setState({ doc_isShow: false });
      }
      else if ( this.state.StockPicks_tr_isShow == true) {
               this.setState({ StockPicks_tr_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }




  
  handleStockPicks_Risk = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.StockPicks_risk_isShow == false) {

               
               this.setState({ StockPicks_risk_isShow: true });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });
               this.setState({ StockPicks_chart_isShow: false });

               this.setState({ active_trades_isShow: false });
               this.setState({ idms_signals_isShow: false });
               this.setState({ mass_communication_isShow: false });

               this.setState({ Dashborad_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
               this.setState({ Feedback_isShow: false });
               this.setState({ doc_isShow: false });
      }
      else if ( this.state.StockPicks_risk_isShow == true) {
               this.setState({ StockPicks_risk_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }

  
  
  handleStockPicks_chart = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.StockPicks_chart_isShow == false) {

               
               this.setState({ StockPicks_chart_isShow: true });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });

               this.setState({ active_trades_isShow: false });
               this.setState({ idms_signals_isShow: false });
               this.setState({ mass_communication_isShow: false });

               this.setState({ Dashborad_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
               this.setState({ Feedback_isShow: false });
               this.setState({ doc_isShow: false });
      }
      else if ( this.state.StockPicks_chart_isShow == true) {
               this.setState({ StockPicks_chart_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }


   
  handleStockPicks_Favorite= async event => {
    event.preventDefault();
    try {
  
      if ( this.state.Favorite_isShow == false) {

               
               this.setState({ Favorite_isShow: true });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });

               this.setState({ active_trades_isShow: false });
               this.setState({ idms_signals_isShow: false });
               this.setState({ mass_communication_isShow: false });

               this.setState({ Dashborad_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
               this.setState({ Feedback_isShow: false });
               this.setState({ doc_isShow: false });
      }
      else if ( this.state.Favorite_isShow == true) {
               this.setState({ Favorite_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }



  handleSignal_Mass_Communication = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.mass_communication_isShow == false) {
               this.setState({ mass_communication_isShow: true });

               this.setState({ active_trades_isShow: false });
               this.setState({ idms_signals_isShow: false });

               this.setState({ Dashborad_isShow: false });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_chart_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });


               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
               this.setState({ Feedback_isShow: false });
               this.setState({ doc_isShow: false });
      }
      else if ( this.state.mass_communication_isShow == true) {
               this.setState({ mass_communication_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }

  



  handleSignal_Feedback= async event => {
    event.preventDefault();
    try {
  
      if ( this.state.Feedback_isShow== false) {
               this.setState({ Feedback_isShow: true });

               this.setState({ mass_communication_isShow: false });
               this.setState({ idms_signals_isShow: false });

               this.setState({ Dashborad_isShow: false });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_chart_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });
               this.setState({ active_trades_isShow: false });


               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
               this.setState({ doc_isShow: false });
      }
      else if ( this.state.Feedback_isShow == true) {
               this.setState({ Feedback_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }



  handleSignal_Doc= async event => {
    event.preventDefault();
    try {
  
      if ( this.state.doc_isShow == false) {
               this.setState({ doc_isShow: true });

               this.setState({ mass_communication_isShow: false });
               this.setState({ idms_signals_isShow: false });

               this.setState({ Dashborad_isShow: false });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_chart_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });
               this.setState({ active_trades_isShow: false });


               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
               this.setState({ Feedback_isShow: false });
      }
      else if ( this.state.doc_isShow == true) {
               this.setState({ doc_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }





  handleSignal_Active_Trades = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.active_trades_isShow == false) {
               this.setState({ active_trades_isShow: true });

               this.setState({ mass_communication_isShow: false });
               this.setState({ idms_signals_isShow: false });

               this.setState({ Dashborad_isShow: false });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_chart_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });


               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
      }
      else if ( this.state.active_trades_isShow == true) {
               this.setState({ active_trades_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }

  
  handleSignal_iDMS_Signals = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.idms_signals_isShow == false) {
               this.setState({ idms_signals_isShow: true });

               this.setState({ mass_communication_isShow: false });
               this.setState({ active_trades_isShow: false });

               this.setState({ Dashborad_isShow: false });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_chart_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });



               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
      }
      else if ( this.state.idms_signals_isShow == true) {
               this.setState({ idms_signals_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }



  handleChart = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.Chart_isShow == false) {
               this.setState({ Chart_isShow: true });

               this.setState({ Dashborad_isShow: false });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });

               this.setState({ active_trades_isShow: false });
               this.setState({ idms_signals_isShow: false });
               this.setState({ mass_communication_isShow: false });


               this.setState({ Signal_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
      }
      else if ( this.state.Chart_isShow == true) {
               this.setState({ Chart_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }

  handleRisk = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.Risk_isShow == false) {
               this.setState({ Risk_isShow: true });

               this.setState({ Dashborad_isShow: false });

               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_risk_isShow: false });
               this.setState({ StockPicks_isShow: false });
               this.setState({ StockPicks_signal_isShow: false });
               this.setState({ StockPicks_tr_isShow: false });

               this.setState({ active_trades_isShow: false });
               this.setState({ idms_signals_isShow: false });
               this.setState({ mass_communication_isShow: false });


               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
      }
      else if ( this.state.Risk_isShow == true) {
               this.setState({ Risk_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }


  handleFinancial = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.Financial_isShow == false) {
               this.setState({ Financial_isShow: true });

               this.setState({ Dashborad_isShow: false });
               this.setState({ StockPicks_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Tracker_isShow: false });
               this.setState({ Simulator_isShow: false });
              
      }
      else if ( this.state.Financial_isShow == true) {
               this.setState({ Financial_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }

  handleTracker = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.Tracker_isShow == false) {
               this.setState({ Tracker_isShow: true });

               this.setState({ Dashborad_isShow: false });
               this.setState({ StockPicks_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Simulator_isShow: false });
              
      }
      else if ( this.state.Tracker_isShow == true) {
               this.setState({ Tracker_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }

  handleSimulator = async event => {
    event.preventDefault();
    try {
  
      if ( this.state.Simulator_isShow == false) {
               this.setState({ Simulator_isShow: true });

               this.setState({ Dashborad_isShow: false });
               this.setState({ StockPicks_isShow: false });
               this.setState({ Signal_isShow: false });
               this.setState({ Chart_isShow: false });
               this.setState({ Risk_isShow: false });
               this.setState({ Financial_isShow: false });
               this.setState({ Tracker_isShow: false });
              
      }
      else if ( this.state.Simulator_isShow == true) {
               this.setState({ Simulator_isShow: false });
       }
  
    }catch(error) {
        console.log(error.message);
    }
  }

  //______________________
  handleMouseHover_Dash() {
    this.setState(this.toggleHoverState_Dash);
  }
  toggleHoverState_Dash(state) {
    return {
      isHovering_Dash: !state.isHovering_Dash,
    };
  }

//______________________
  handleMouseHover_Picks() {
    this.setState(this.toggleHoverState_Picks);
    
  }

  toggleHoverState_Picks(state) {
    return {
      isHovering_Picks: !state.isHovering_Picks,
    };
  }

  //______________________

  handleMouseHover_Signal() {
    this.setState(this.toggleHoverState_Signal);
  }

  toggleHoverState_Signal(state) {
    return {
      isHovering_Signal: !state.isHovering_Signal,
    };
  }

  //______________________

  handleMouseHover_Risk() {
    this.setState(this.toggleHoverState_Risk);
  }

  toggleHoverState_Risk(state) {
    return {
      isHovering_Risk: !state.isHovering_Risk,
    };
  }


  //______________________
  handleMouseHover_Chart() {
    this.setState(this.toggleHoverState_Chart);
  }

  toggleHoverState_Chart(state) {
    return {
      isHovering_Chart: !state.isHovering_Chart,
    };
  }

  //______________________

  handleMouseHover_Simulator() {
    this.setState(this.toggleHoverState_Simulator);
  }

  toggleHoverState_Simulator(state) {
    return {
      isHovering_Simulator: !state.isHovering_Simulator,
    };
  }
    //______________________

    //______________________

  handleMouseHover_Report() {
    this.setState(this.toggleHoverState_Report);
  }

  toggleHoverState_Report(state) {
    return {
      isHovering_Report: !state.isHovering_Report,
    };

    /*
    
    
                    {
                      this.state.isHovering_Picks &&
                      <div className="left_leran">
                        Click for more / less information! 🐱
                      </div>
                    }
    
    */

                   // <a        onMouseEnter={this.handleStockPicks}     onMouseLeave={this.handleStockPicks}   onClick={this.handleStockPicks} className="logo-position"  id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_11.jpg"></img><span className="doc-content-title">Stock Picks - IDMS Trading Platform Tool</span></a> 
  }
    //______________________


    


  
  render() {

    //<h4 className="card-title mt-1">I'm PageTwo!</h4>
  return (

    <AbsoluteWrapper>
      <section className="row justify-content-center text-center p-5">
        <article className="col-md-8">
          <div className="card p-1 m-1 shadow">
            <div className="card-body">
             
              <img src= {process.env.PUBLIC_URL  + "./pictures/images_14.jpg" }  width="108%"  height="500px" ></img>

              </div>
            
            </div>
  
              <br></br>
              <br></br>
              <br></br>
  
            <h4  style = {{color: 'rgb(43, 97, 245)'}} >What's Included in Your Solution</h4>
            <div className="wrapper-line-login"></div>
  
            <br></br>
  

  
            <div   id = "picks_solution1"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a        onClick={this.handleStockPicks_stockPick} className="logo-position"  id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">iDMS Trading Platform Tool  - US stocks, CFDs and Cryptocurrencies</span></a> 
                     
                      <br></br>

                     <div className="wrapper_line"></div>
                     <br></br>

                     <p id="page_summary_idx" className="text-position">

                          <span>	The platform’s intelligence layer provides:</span>

                          <br></br>

                          <span>	• &nbsp; &nbsp; 	 Real-time market mapping and chart visualization</span>
                          <span>	• &nbsp; &nbsp; 	 Structured signal generation and event-driven alerts </span>
                          <span>	• &nbsp; &nbsp; 	 Identification of hypothetical high-probability trading opportunities  </span>
                          <span>	• &nbsp; &nbsp; 	 Structured indicator-state classification and regime modeling   </span>

                          <br></br>

                          <span>	The platform continuously analyzes :</span>

                          <br></br>
                          <span>	• &nbsp; &nbsp; 	Multi-timeframe indicator relationships </span>
                          <span>	• &nbsp; &nbsp; 	Momentum and volatility regimes </span>
                          <span>	• &nbsp; &nbsp; 	Market structure transitions </span>
                          <span>	• &nbsp; &nbsp; 	Liquidity and directional bias conditions </span>
                          <span>	• &nbsp; &nbsp; 	Strategy-state alignment probabilities </span>
                          <span>	• &nbsp; &nbsp; 	Cross-market behavioral correlations </span>
                          
                          

                          <br></br>


                    </p>

                    {this.state.StockPicks_isShow === true  && (
                    <div>

                          <span>Our engine provide, mapping chart, signals and alerts for a hypothetical transactions as potentially profitable trades to be bought or sold within 10 mn timeframe defined as time risk.</span>
                          <span>We provide as well live list of best and worst performers of stock included in the underlying watchlist .</span>
                          <br></br>
                          <br></br>
                           <img src={MainPage}  width="100%"  /> 
                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>


            <br></br>



            <div   id = "picks_solution1"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a        onClick={this.handleStockPicks_stockPick} className="logo-position"  id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">API & Brokerage Integration</span></a> 
                     
                      <br></br>

                     <div className="wrapper_line"></div>
                     <br></br>

                     <p id="page_summary_idx" className="text-position">

                          <span>	The platform integrates built-in API connectivity with MetaTrader 5, Ndax and Interactive Brokers (IBKR) to support automated trade execution, transaction synchronization, and real-time communication between the analytical environment and brokerage infrastructure.</span>
                          <br></br>
                          <span>	Our API-driven architecture enables:</span>

                          <br></br>

                          <span>	• &nbsp; &nbsp; 	 Real-time transaction routing and execution</span>
                          <span>	• &nbsp; &nbsp; 	 Secure broker-to-platform communication </span>
                          <span>	• &nbsp; &nbsp; 	 Automated order synchronization </span>
                          <span>	• &nbsp; &nbsp; 	 Multi-account trading connectivity</span>
                          <span>	• &nbsp; &nbsp; 	 Copy-trading and signal distribution workflows</span>
                          <span>	• &nbsp; &nbsp; 	 Live position and portfolio monitoring</span>
                          <span>	• &nbsp; &nbsp; 	 Execution-status and order lifecycle tracking </span>
                          <span>	• &nbsp; &nbsp; 	 Cloud-based trading infrastructure integration</span>

                          <br></br>

                          
                    </p>

                    {this.state.APIs_isShow === true  && (
                    <div>

                          <span>Our engine provide, mapping chart, signals and alerts for a hypothetical transactions as potentially profitable trades to be bought or sold within 10 mn timeframe defined as time risk.</span>
                          <span>We provide as well live list of best and worst performers of stock included in the underlying watchlist .</span>
                          <br></br>
                          <br></br>

                          <img src={Favorite}   width="100%"  />
                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>


            <br></br>


                        <div   id = "picks_solution1"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a        onClick={this.handleStockPicks_Favorite} className="logo-position"  id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Interactive & Custumizable Watchlist</span></a> 
                     
                      <br></br>

                     <div className="wrapper_line"></div>
                     <br></br>

                     <p id="page_summary_idx" className="text-position">

                          <span>The platform provides a dynamic and interactive watchlist environment that enables users to customize, organize, and monitor preferred instruments in real time based on individual trading strategies, market focus, and analytical preferences. </span>

                          <br></br>

                          
                    </p>

                    {this.state.Favorite_isShow === true  && (
                    <div>

                          <span>Our engine provide, mapping chart, signals and alerts for a hypothetical transactions as potentially profitable trades to be bought or sold within 10 mn timeframe defined as time risk.</span>
                          <span>We provide as well live list of best and worst performers of stock included in the underlying watchlist .</span>
                          <br></br>
                          <br></br>

                          <img src={Favorite}    width="100%"  />
                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>

            
            <br></br>





            <div   id = "picks_solution5"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a      onClick={this.handleStockPicks_chart} className="logo-position"  id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Charts, Mapping and Indicators</span></a> 
                    
                      <br></br>

                    <div className="wrapper_line"></div>
                    <br></br>

                    <p id="page_summary_idx" className="text-position">
                          <span>Charting & Visualization Features : </span>

                           <br></br>

                          <span>• &nbsp; &nbsp; 	 Interactive intraday and daily market charts </span>
                          <span>• &nbsp; &nbsp; 	 Advanced candlestick and trend-line visualization </span>
                          <span>• &nbsp; &nbsp; 	 Real-time multi-timeframe market mapping </span>
                          <span>• &nbsp; &nbsp; 	Integrated volatility and momentum analysis </span>
                          <span>• &nbsp; &nbsp; 	 Event-driven signal overlays and alert markers </span>
                          <span>• &nbsp; &nbsp; 	 Integrated technical analysis layers </span>

                          <br></br>

                         
                    </p>

                    {this.state.StockPicks_chart_isShow === true  && (
                    <div>

                          <span>Our approach is driven by the best techniques of artificial intelligence including machine learning and deep learning components over many years of historical data. </span>
                          <br></br>
                          <br></br>

                          <img src={react_chart} width="100%" />
                          <br></br>  
                          <br></br> 
                          <img src= {mapping}  height = "100%"/>
                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>
            <br></br>




            <div   id = "picks_solution2"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a        onClick={this.handleStockPicks_Signals} className="logo-position"  id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Alerts & Signals </span></a> 
                    
                      <br></br>

                    <div className="wrapper_line"></div>
                    <br></br>

                    <p id="page_summary_idx" className="text-position">
                          <span>During active market hours, the platform continuously delivers real-time trading signals and event-driven alerts designed to identify potential buy and sell opportunities within short-term intraday market conditions typical 10-minute holding-period framework, internally defined as the platform’s “time-risk” horizon..</span>
                          
                       
                          
                          <br></br>
                          <span>Rather than generating isolated alerts, the environment contextualizes each signal through momentum analysis, volatility behavior, multi-timeframe confirmation, and structured market-state classification.</span>
                          <br></br>
                          
                          <span>Signal & Alert Categories :</span>
                          
                          <br></br>
                          <span>• &nbsp; &nbsp; 	 Momentum UpTrend Signals</span>
                          <span>• &nbsp; &nbsp; 	 Reversal Trend Signals</span>
                          <span>• &nbsp; &nbsp; 	 Momentum DownTrend Signals</span>

                           <br></br>


                    </p>

                   
                    {this.state.StockPicks_signal_isShow === true  && (
                    <div>

                          <span>Our approach is driven by the best techniques of artificial intelligence including machine learning and deep learning components over many years of historical data. </span>
                          <br></br>
                          <br></br>

                          <img src={Alerts}    width="80%"  />
                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>
            <br></br>





            <div   id = "picks_solution3"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a      onClick={this.handleStockPicks_eoc} className="logo-position"  id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">MCycle™ — Momentum Cycle Trigger</span></a> 
                    
                      <br></br>

                    <div className="wrapper_line"></div>
                    <br></br>

                    <p id="page_summary_idx" className="text-position">
                          <span>For the first time, the platform introduces a proprietary analytical concept known as MCycle™ (Momentum Cycle Trigger).</span>
                          <span>MCycle™ is designed to identify potential endings or exhaustion phases of active momentum cycles by analyzing structured transitions in indicator-state behavior, volatility pressure, and directional momentum degradation.</span>

                          <br></br>
                         
                        
                    </p>

                    {this.state.StockPicks_eoc_isShow === true  && (
                    <div>

                          <span>Our approach is driven by the best techniques of artificial intelligence including machine learning and deep learning components over many years of historical data. </span>
                          <br></br>
                          <br></br>

                          <img src={EOCycle}    height="500px%"  width="80%"/>
                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>
            <br></br>




            <div   id = "picks_solution3"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a      onClick={this.handleStockPicks_TradingRange} className="logo-position"  id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Trading Range Vector™ </span></a> 
                    
                      <br></br>

                    <div className="wrapper_line"></div>
                    <br></br>

                    <p id="page_summary_idx" className="text-position">
                          <span>Trading Range Vector™ (TRV) is an innovative market-mapping and risk-governance framework designed to identify the “True Trading Range” (TTR) of an instrument in real time.</span>
                          <span>The system combines volatility analytics, pivot structures, trend-line mapping, and multi-factor technical analysis to define the most relevant dynamic support and resistance zones surrounding current market activity.</span>
                          <span>Rather than relying on static price levels alone, TRV continuously evaluates evolving market conditions to generate a structured trading-range environment used to support risk-aware investment decisions..</span>

                          
                          <br></br>
                         
                        
                    </p>

                    {this.state.StockPicks_tr_isShow === true  && (
                    <div>

                          <span>Our approach is driven by the best techniques of artificial intelligence including machine learning and deep learning components over many years of historical data. </span>
                          <br></br>
                          <br></br>

                          <img src={TradingRange}     height="500px%"  width="80%"/>
                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>
            <br></br>



  
            <div   id = "risk_solution"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >
            <br></br>
            <a     onClick={this.handleRisk}  className="logo-position"  id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Risk Management - Quantitative Risk Framework</span></a>
            
            
            
            <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                     <p id="page_summary_idx" className="text-position">
                          <span>The platform provides :</span>
                          <br></br>
                          <span>• &nbsp; &nbsp; 	    Risk-neutral and mean-reverting pricing models </span>
                          <span>• &nbsp; &nbsp; 	    Seasonality-adjusted market behavior analysis  </span>
                          <span>• &nbsp; &nbsp; 	    Jump-diffusion volatility modeling  </span>
                          <span>• &nbsp; &nbsp; 	    Simulated price-path generation and scenario analysis  </span>
                          <span>• &nbsp; &nbsp; 	    Dynamic exposure and drawdown monitoring  </span>
                          <span>• &nbsp; &nbsp; 	    Real-time portfolio risk visualization </span>
                          <span>• &nbsp; &nbsp; 	    Volatility-aware stop-loss and risk calibration tools </span>
                     </p>

                  

                    {this.state.Risk_isShow == true  && (
                    <div>
                       <span>The risk metric can be used by investors to determine the extent and occurrence ratio of potential losses given any new transaction.</span>
                       <span>The risk profile curve and price path distribution interfaces estimate the risk and future price probability for transactional analysis such as exit strategy and What-If scenario simulation.</span>
                       <br></br>  
                       <br></br>  
                          <img src={riskMetrics}    width="80%"  />

                         
                    </div>
                    )} 
                    <br></br>
            </div>
            <br></br>

  
            

            <div   id = "signal_solution"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

                <br></br>
                <a     onClick={this.handleSignal_Active_Trades}  className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Reporting System </span></a>

                <br></br>
                        <div className="wrapper_line"></div>
                        <br></br>
                        <p id="page_summary_idx" className="text-position">
                        <span>For research, validation, and backtesting purposes, the system continuously records and structures historical trading intelligence data, including:</span>

                        <br></br>
                        <span>• &nbsp; &nbsp; 	  Daily market activity logs </span>
                        <span>• &nbsp; &nbsp; 	  Historical iDMS signal records  </span>
                        <span>• &nbsp; &nbsp; 	  Entry-position state profiles  </span>
                        <span>• &nbsp; &nbsp; 	 	Open-position behavioral tracking </span>
                        <span>• &nbsp; &nbsp; 	  Trade lifecycle monitoring </span>
                        <span>• &nbsp; &nbsp; 	  Hypothetical transaction performance history  </span>
                        <span>• &nbsp; &nbsp; 	  Indicator-state transition history   </span>
                        <span>• &nbsp; &nbsp; 	 	Strategy-event timelines </span>

                        <br></br>



                        </p>

                        {this.state.active_trades_isShow === true  && (
                        <div>
                              <img src={Trade_History}    width="80%"  />
                              <img src={OpenedPosition}   width="80%"  />
                              <br></br>  
                        </div>
                        


                        )} 
                        <br></br>
                </div>
                <br></br>


           <div   id = "signal_solution"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a    onClick={this.handleSignal_Feedback}  className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Feedback Center</span></a>
            
            <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                     <p id="page_summary_idx" className="text-position">
                     <span>Designed to improve platform intelligence and user experience, the Feedback Center captures and organizes user-driven operational insights, including:</span>
                     <br></br>

                     <span>• &nbsp; &nbsp;  System performance feedback</span>
                     <span>• &nbsp; &nbsp;  Signal quality evaluations</span>
                     <span>• &nbsp; &nbsp;  Strategy behavior observations</span>
                     <span>• &nbsp; &nbsp;  Trade execution issue reports</span>
                     <span>• &nbsp; &nbsp;  Feature requests and enhancement suggestions</span>
                     <span>• &nbsp; &nbsp;  Platform usability assessments</span>
                     <span>• &nbsp; &nbsp;  Error and anomaly reporting</span>
                     <span>• &nbsp; &nbsp;  Real-time user sentiment tracking</span>

                    </p>

                    {this.state.Feedback_isShow === true  && (
                    <div>
                          <img src={feedback}   width="80%"  />
                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>
            <br></br>  


            <div   id = "signal_solution"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a    onClick={this.handleSignal_Doc}  className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Documentation Center</span></a>
            
            <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                     <p id="page_summary_idx" className="text-position">
                     <span>Built to support operational clarity and system transparency, the Documentation Center centralizes technical and strategic references, including :</span>
                     <br></br>

                     <span>• &nbsp; &nbsp;  Platform architecture overviews</span>
                     <span>• &nbsp; &nbsp;  Indicator logic documentation</span>
                     <span>• &nbsp; &nbsp;  Strategy configuration guides</span>
                     <span>• &nbsp; &nbsp;  Signal interpretation manuals</span>
                     <span>• &nbsp; &nbsp;  Risk management framework references</span>
                     <span>• &nbsp; &nbsp;  Trade execution workflow documentation</span>
                     <span>• &nbsp; &nbsp;  System integration and API references</span>
                     <span>• &nbsp; &nbsp;  Version updates and release notes</span>

                    </p>

                    {this.state.doc_isShow === true  && (
                    <div>
                          <img src={doc}   width="80%"  />
                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>
            <br></br>     
   



          <div   id = "signal_solution"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a    onClick={this.handleSignal_Mass_Communication}  className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Mass Communication System</span></a>
            
            <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                     <p id="page_summary_idx" className="text-position">
                     <span>This live mass communication system is used as an important channel to communicate as needed a major market information generated by our admin console system. </span>
                    </p>

                    {this.state.mass_communication_isShow === true  && (
                    <div>
                          <img src={MassCom}   width="80%"  />
                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>
            <br></br>

            <div   id = "signal_solution"    className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }}  >

            <br></br>
            <a   className="logo-position"   id ="Strategy" aria-expanded="false" ><img className=""  width="30px" height="30px" src="./pictures/images_12.jpg"></img><span className="doc-content-title">Legendary Community - Coming Soon</span></a>
            
            <br></br>
                     <div className="wrapper_line"></div>
                     <br></br>
                     <p id="page_summary_idx" className="text-position">
                     <span></span>
                     <span></span>
                    </p>

                    {this.state.Financial_isShow === true  && (
                    <div>
                          <img src={process.env.PUBLIC_URL  +"/pictures/idms_report_nvda.png"}    width="80%"  />

                          <br></br>  
                    </div>
                    )} 
                    <br></br>
            </div>
            <br></br>


            
  
  
           


        </article>
      </section>
    </AbsoluteWrapper>
    )
  }
}

export default Solutions;
